import { probytoaiOverviewConstants } from '../_constants';

export function listReports(state = {}, action) {
    switch (action.type) {
      case probytoaiOverviewConstants.GETALL_WEEKLY_REPORTS_REQUEST:
        return {
          loading: true
        };
      case probytoaiOverviewConstants.GETALL_WEEKLY_REPORTS_SUCCESS:
        return {
          items: action.reports
        };
      case probytoaiOverviewConstants.GETALL_WEEKLY_REPORTS_FAILURE:
        return { 
          error: action.error
        };
      default:
        return state
    }
  }

  export function ideaDashboardDetails(state = {}, action) {
    switch (action.type) {
      case probytoaiOverviewConstants.GET_IDEA_DASHBOARD_DETAILS_REQUEST:
        return {
          loading: true,
        };
      case probytoaiOverviewConstants.GET_IDEA_DASHBOARD_DETAILS_SUCCESS:
        return {
          item: action.idea,
        };
      case probytoaiOverviewConstants.GET_IDEA_DASHBOARD_DETAILS_FAILURE:
        return {
          error: action.error,
        };
      default:
        return state;
    }
  }

  export function countAndUpdates(state = {}, action) {
    switch (action.type) {
      case probytoaiOverviewConstants.GETALL_COUNTS_AND_UPDATES_REQUEST:
        return {
          loading: true
        };
      case probytoaiOverviewConstants.GETALL_COUNTS_AND_UPDATES_SUCCESS:
        return {
          items: action.counts
        };
      case probytoaiOverviewConstants.GETALL_COUNTS_AND_UPDATES_FAILURE:
        return { 
          error: action.error
        };
      default:
        return state
    }
  }



  
export function overviewChartData(state = {}, action) {
  switch (action.type) {
    case probytoaiOverviewConstants.GETALL_OVERVIEW_CHART_DATA_REQUEST:
      return {
        loading: true
      };
    case probytoaiOverviewConstants.GETALL_OVERVIEW_CHART_DATA_SUCCESS:
      return {
        items: action.overviewChartData
      };
    case probytoaiOverviewConstants.GETALL_OVERVIEW_CHART_DATA_FAILURE:
      return { 
        error: action.error
      };
    default:
      return state
  }
}

export function overviewROIChartData(state = {}, action) {
  switch (action.type) {
    case probytoaiOverviewConstants.GETALL_OVERVIEW_ROI_CHART_DATA_REQUEST:
      return {
        loading: true
      };
    case probytoaiOverviewConstants.GETALL_OVERVIEW_ROI_CHART_DATA_SUCCESS:
      return {
        items: action.overviewROIChartData
      };
    case probytoaiOverviewConstants.GETALL_OVERVIEW_ROI_CHART_DATA_FAILURE:
      return { 
        error: action.error
      };
    default:
      return state
  }
}
